export const initialState: State.PersonLevelExemptions = {
  getPersonLevelExemptions: [],
  isFetched: false,
};
